module.exports = __webpack_public_path__ + "static/img/main.1e9670a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/4/main.png
// module id = KoMk
// module chunks = 1